// Копирайт приватности — spec/08_copy.md, раздел «Статистика и профиль» (часть privacy.*).
// Ирония здесь выключена полностью (тревожный сценарий — удаление данных, CLAUDE.md правило 19).
import { textByGender } from '@lunya/contracts'

import type { PrivacyCopy } from './types'

export const privacy: PrivacyCopy = {
  title: 'Что я о тебе знаю',
  not_service: 'Я не служба спасения. Если человеку правда плохо — звони ему, а не мне.',
  delete: 'Удалить все мои данные',
  delete_body:
    'Сотру профиль, отметки, связи и историю проверок. Твои связи просто перестанут тебя видеть — без уведомлений. Вернуть будет нечего.',
  delete_cta: 'Удалить навсегда',
  data_title: 'Что я храню',
  data_body: ({ gender }) =>
    textByGender(
      gender,
      'Имя и аватар из Telegram, дату рождения — и время с городом, если ты их {дал|дала}. Отметки состояния по дням, лучики и связи.',
      'Имя и аватар из Telegram, дату рождения — и время с городом, если они указаны. Отметки состояния по дням, лучики и связи.',
    ),
  // Раньше тут было «видят только сегодняшнюю отметку и неделю» — и это перестало быть
  // правдой. Связь отдаёт второй стороне данные рождения: ими заполняется ряд «из твоих уз»
  // в совместимости и в натальной карте (`linkPartnerSchema`). Обещание переписано под то,
  // что мы отдаём на самом деле: обратное — врать на юридически значимом экране.
  links_see:
    'Твои связи видят твою сегодняшнюю отметку, неделю и данные рождения — дату, а если они указаны, то время и город: ими заполняются их расчёты совместимости и карты. Ни переписки, ни истории просмотров, ни списка других твоих связей.',
  sell_label: 'Кому продаём данные',
  sell_value: 'никому',
  others_label: 'Данные чужих из проверок',
  others_value: 'только у тебя',
  // Шеврон строки рисует `Icon name='chevron-right'`, поэтому в самой строке его нет:
  // раньше «›» стоял и в тексте, и иконкой, и на экране их было два подряд.
  offer: 'Оферта и условия',
  // Этот экран рассказывает своими словами, политика — документ. Связка между ними обязана
  // быть явной: человек, дочитавший до «кому продаём данные», должен видеть, где то же самое
  // написано полностью и по закону (docs/legal.md §13.5).
  policy_note:
    'Здесь я рассказала своими словами. Полностью и по закону — в документе: кто отвечает за данные, зачем они нужны, сколько хранятся и как их забрать.',
  policy: 'Политика обработки персональных данных',
}
